import apiPrakasak from "../../api/apiPrakasak";

//?-----------------Overall Dashboard APIs----------------------
export const getOverallDashboard = async () => {
  return apiPrakasak.post("/getDashboardReport/static");
};

export const saveOverallDashboard = async (body) => {
  return apiPrakasak.post("/saveOverallDashboard", body);
};

//&------------------Dashboard Monthly APIs---------------------
export const getDashboardMonthly = async () => {
  return apiPrakasak.post("/getDashboardMonthly/static");
};

export const saveDashboardMonthly = async (body) => {
  return apiPrakasak.post("/saveDashboardMonthly", body);
};

//~--------------------Remote Instructions APIs (Weekly)------------------
export const getRemoteInstructionsWeeklyData = async () => {
  return apiPrakasak.post("/getRemoteInstMonthly/static");
};

export const saveRemoteInstructionsWeeklyData = async (body) => {
  return apiPrakasak.post("/saveRemoteInstMonthly", body);
};

//!---------------------Remote Instructions APIs (Monthly)--------------
export const getRemoteInstructionsMonthlyData = async () => {
  return apiPrakasak.post("/getRemoteInst/static");
};

export const saveRemoteInstructionsMonthlyData = async (body) => {
  return apiPrakasak.post("/saveRemoteInst", body);
};

//^---------------Monthly Unique Users APIs---------------------
export const getMonthlyUniqueUsers = async () => {
  const body = {
    year: 2024,
    // userType: "smartPhone",
  };
  return apiPrakasak.post("/getMonthlyUniqueUsers/static", body);
};

export const saveMonthlyUniqueUsers = async (body) => {
  return apiPrakasak.post("/saveMonthlyUniqueUsers", body);
};

//@----------------------WhatsAppBot APIs----------------------------
// Monthly
export const getWhatsappBotMonthlyData = async () => {
  return apiPrakasak.post("/getWhatsAppMonthly/static");
};

export const saveWhatsappBotMonthlyData = async (body) => {
  return apiPrakasak.post("/saveWhatsappBotMonthly", body);
};

// Weekly
export const getWhatsappBotWeeklyData = async () => {
  return apiPrakasak.post("/getWhatsAppWeekly/static");
};

export const saveWhatsappBotWeeklyData = async (body) => {
  return apiPrakasak.post("/saveWhatsappBotWeekly", body);
};

//#----------------------School-Wise APIs----------------------------
// School-Wise Data
export const getSchoolwiseData = async () => {
  return apiPrakasak.post("/getSchoolwise/static");
};

export const saveSchoolwiseData = async (body) => {
  return apiPrakasak.post("/saveSchoolWise", body);
};

// School-Wise Performance Data
export const getSchoolwisePerformanceData = async () => {
  return apiPrakasak.post("/getSchoolwisePerformance/static");
};

export const saveSchoolwisePerformanceData = async (body) => {
  return apiPrakasak.post("/saveSchoolWisePerf", body);
};

//#-----------------------Anganwadi-Wise APIs----------------------------
//Anganwadi-Wise data
export const saveAnganwadiwiseData = async (body) => {
  return apiPrakasak.post("/saveAnganwadiWise", body);
};

export const getAnganwadiwiseData = async () => {
  return await apiPrakasak.post("/getAnganwadiWise/static");
};

//Anganwadi-Wise Performance Data
export const saveAnganwadiWisePerformanceData = async (body) => {
  return await apiPrakasak.post("/saveAnganwadiWisePerf", body);
};

export const getAnganwadiwisePerformanceData = async () => {
  return await apiPrakasak.post("/getAnganwadiWisePerformance/static");
};

//*----------------------Retention Metrics APIs----------------------
export const getRetentionMetricsData = async () => {
  return apiPrakasak.post("/getRetentionMetrics/static");
};

export const saveRetentionMetricsData = async (body) => {
  return apiPrakasak.post("/saveRetentionMetrics", body);
};

//*----------------------Static District Blocks APIs----------------------
export const getStaticDistBlocks = async () => {
  return apiPrakasak.post("/getDistBlocks/static");
};

export const saveStaticDistBlocks = async (body) => {
  return await apiPrakasak.post("/saveStaticDistBlocks", body);
};
